import { PercentPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { Table } from '../constants/table.constants';

@Pipe({ name: 'bpsToPercent' })
/** BP = basis point, equal to 1/100 of a percent. */
export class BpsToPercentPipe implements PipeTransform {
    constructor(private _percentPipe: PercentPipe) {}

    public transform(value: string | number, divisor = 1): string {
        let normalizedValue: number;
        if (!!value && typeof value === 'string') {
            normalizedValue = parseInt(value, 10);
        } else {
            normalizedValue = value as number;
        }
        return !!normalizedValue
            ? this._percentPipe.transform(normalizedValue / Math.pow(10, 4) / divisor, '1.2-2')
            : Table.NullAmount;
    }
}
